export interface ResourcesTranslations {
  hotlines: string;
  resources: string;
}

export const resourcesTranslationKeys: ResourcesTranslations = {
  hotlines: 'hotlines',
  resources: 'resources',
};

export const resourcesTranslationsEN: ResourcesTranslations = {
  hotlines: 'Hotlines',
  resources: 'Resources',
};

export const resourcesTranslationsES: ResourcesTranslations = {
  hotlines: 'Líneas directas',
  resources: 'Recursos',
};
